// React Third-Party Libraries
import { Form, message } from "antd";
import { useDispatch } from "react-redux";
import { useEffect } from 'react';

// Constants Library

// Components Library
import DrawerFromGroup from "../DrawerFormGroup";

// Services Library

// Redux Actions
import * as REDUX_ACTION from "../../../../../../services/redux/actions";

const DrawerEditGroup = (props) => {
  const { isOpen, setIsOpen, data } = props;


  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm(); 

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue(data);
    }
  }, [isOpen]);

  const handleSave = () => {
    form
      .validateFields()
      .then((record) => {

        const { groupName, groupColor } = record;

        const updatedRecord = {
          name: groupName,
          color: groupColor,
        };

        const formData = {
          groupid: data.groupid,
          createdBy: data.createdBy || new Date().toLocaleDateString(),
          items: updatedRecord,
        };
    
        messageApi.open({
          type: "loading",
          content: "Updating...",
          duration: 0,
        });
        
        dispatch(REDUX_ACTION.v1_group.update_group_request(formData, () => {
          messageApi.destroy();
          setIsOpen(false);
        }));
      })
      .catch((err) => {
        message.error("fill the form");
      });
  };

  return (
    <>
      {contextHolder}
      <DrawerFromGroup
        form={form}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        type="edit"
        initialCheckedValue={data.groupColor}
        handleSave={handleSave}
      />

    </>
  );
};

export default DrawerEditGroup;
